import "./RASSScore.scss";
import { Header } from "../Header/Header";
import SideBar from "../SideBar/Sidebar";
import redRating from "../../common/icons/svg/red-rating.svg";
import yellowRating from "../../common/icons/svg/yellow-rating.svg";
import greenRating from "../../common/icons/svg/green-rating.svg";
import React, { useState, useEffect } from 'react';

function RASSScore(props) {
    const [rassRating, setRassRating] = useState(0);

    const handleRassRatingRadio = (rating) => {
        setRassRating(rating);
    }

    return (
        <div className="rass-score-container">
            <Header
            // handleWardChange={(item) => setSelectedWard(item)}
            // wardOption={wardOption}
            // selectedWard={selectedWard} 
            />
            <SideBar />
            <div className="rass-score-body">
                <div className="rass-heading-container">
                    <span className="heading">RASS Score</span>
                    <div className={`show-score
                                        ${((rassRating <= -2 && rassRating >= -5) || (rassRating >= 2 && rassRating <= 4)) ? "red-score" : ""} 
                                        ${(rassRating === -1) || (rassRating === 1) ? "yellow-score" : ""}
                                        ${rassRating === 0 ? "green-score" : ""}
                                         `}>Score: {rassRating}</div>
                </div>
                <div className="rass-rating-container">
                    <div className="common-rating-cls">
                        <img className="rating-color" src={redRating} />
                        <span>Severe: (-5 to -2 and 2 to 4)</span>
                    </div>
                    <div className="common-rating-cls">
                        <img className="rating-color" src={yellowRating} />
                        <span>Moderate: -1 and 1</span>
                    </div>
                    <div className="common-rating-cls">
                        <img className="rating-color" src={greenRating} />
                        <span>Safe: 0</span>
                    </div>
                </div>
                <div className="rass-mcq-container">
                    <div className="common-mcq">
                        <div className="mcq-heading">Sensory perception</div>
                        <div className="mcq-score">{rassRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="combative-danger-to-staff" name="rass-score" onClick={() => handleRassRatingRadio(4)} />
                                <label htmlFor="combative-danger-to-staff">Combative, violet, danger to staff (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="pulls-removes-tube" name="rass-score" onClick={() => handleRassRatingRadio(3)} />
                                <label htmlFor="pulls-removes-tube">Pulls or removes tube(s) or catheters; aggressive (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="frequent-movements" name="rass-score" onClick={() => handleRassRatingRadio(2)} />
                                <label htmlFor="frequent-movements">Frequent nonpurposeful movement, fights ventilator (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="anxious-apprehensive" name="rass-score" onClick={() => handleRassRatingRadio(1)} />
                                <label htmlFor="anxious-apprehensive">Anxious, apprehensive, but not aggressive (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="alert-calm" name="rass-score" onClick={() => handleRassRatingRadio(0)} />
                                <label htmlFor="alert-calm">Alert and calm (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="awakens-to-voice" name="rass-score" onClick={() => handleRassRatingRadio(-1)} />
                                <label htmlFor="awakens-to-voice">Awakens to voice (eye opening/contact) &#62; 10 seconds (-1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="light-sedation" name="rass-score" onClick={() => handleRassRatingRadio(-2)} />
                                <label htmlFor="light-sedation">Light sedation; briefly awakens to voice (eye opening/contant) &#60; 10 seconds (-2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="moderate-sedation" name="rass-score" onClick={() => handleRassRatingRadio(-3)} />
                                <label htmlFor="moderate-sedation">Moderate sedation; movement or eye opening. No eye contact(-3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="deep-sedation" name="rass-score" onClick={() => handleRassRatingRadio(-4)} />
                                <label htmlFor="deep-sedation">Deep sedation; no response to voice, but movement or eye opening to physical stimulation (-4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="unarousable" name="rass-score" onClick={() => handleRassRatingRadio(-5)} />
                                <label htmlFor="unarousable">Unarousable; no response to voice or physical stimulation (-5)</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rass-total-rating-container">
                    <span>Total RASS Score</span>
                    <div className="total-rating">{rassRating}</div>
                </div>
                <div className="submit-btn-container">
                    <div className="submit-btn" onClick={() => props.handleSubmitClick(rassRating)}>Submit</div>
                </div>
            </div>
        </div >
    )
}
export default RASSScore;
